import React, { useState } from "react";
import { Link } from "react-router-dom";
import ConsultancyNavbar from "../ConsultancyNavbar";
import ConsultancyFooter from "../ConsultancyFooter";

const UniversitiesPage = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("all");

  const uniCatalog = [
    { id: 1, name: "University of Oxford", country: "United Kingdom", flag: "🇬🇧", rank: "#1 World", fee: "£28,000 / yr", popular: "Computer Science, Law, Medicine", img: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?auto=format&fit=crop&w=600&q=80" },
    { id: 2, name: "Harvard University", country: "United States", flag: "🇺🇸", rank: "#3 World", fee: "$54,000 / yr", popular: "MBA, Business, Biotech, Law", img: "https://images.unsplash.com/photo-1562774053-701939374585?auto=format&fit=crop&w=600&q=80" },
    { id: 3, name: "University of Toronto", country: "Canada", flag: "🇨🇦", rank: "#18 World", fee: "CAD 45,000 / yr", popular: "AI, Data Science, Finance", img: "https://images.unsplash.com/photo-1592280771190-3e2e4d571952?auto=format&fit=crop&w=600&q=80" },
    { id: 4, name: "University of Melbourne", country: "Australia", flag: "🇦🇺", rank: "#14 World", fee: "AUD 44,000 / yr", popular: "Engineering, Cyber Security", img: "https://images.unsplash.com/photo-1607237138185-eedd9c632b0b?auto=format&fit=crop&w=600&q=80" },
    { id: 5, name: "Technical University of Munich", country: "Germany", flag: "🇩🇪", rank: "#37 World", fee: "€0 (Tuition Free)", popular: "Automotive, Robotics, AI", img: "https://images.unsplash.com/photo-1580582932707-520aed937b7b?auto=format&fit=crop&w=600&q=80" },
    { id: 6, name: "Trinity College Dublin", country: "Ireland", flag: "🇮🇪", rank: "#81 World", fee: "€22,000 / yr", popular: "Pharma, Cloud Tech, Economics", img: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?auto=format&fit=crop&w=600&q=80" },
  ];

  const filtered = uniCatalog.filter((u) => {
    const matchesSearch = u.name.toLowerCase().includes(searchTerm.toLowerCase()) || u.popular.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCountry = selectedCountry === "all" || u.country.toLowerCase().includes(selectedCountry.toLowerCase());
    return matchesSearch && matchesCountry;
  });

  return (
    <div className="consultancy-wrapper">
      <ConsultancyNavbar />

      {/* Header Banner */}
      <section className="py-5 consultancy-section-dark text-center">
        <div className="container">
          <span className="consultancy-badge-gold mb-2">University Discovery Platform</span>
          <h1 className="display-5 font-weight-bold consultancy-gold-title mb-3">Explore 500+ Partner Universities</h1>
          <p className="consultancy-lead-text mx-auto mb-4" style={{ maxWidth: "650px" }}>
            Search top-ranked global universities, compare tuition fees, QS rankings, and entry requirements.
          </p>

          {/* Search & Filter Bar */}
          <div className="row g-2 justify-content-center mx-auto" style={{ maxWidth: "700px" }}>
            <div className="col-md-7">
              <input
                type="text"
                className="form-control consultancy-form-control"
                placeholder="Search university or program name..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="col-md-5">
              <select className="form-select consultancy-form-control" value={selectedCountry} onChange={(e) => setSelectedCountry(e.target.value)}>
                <option value="all">All Countries</option>
                <option value="uk">United Kingdom</option>
                <option value="united states">United States</option>
                <option value="canada">Canada</option>
                <option value="australia">Australia</option>
                <option value="germany">Germany</option>
                <option value="ireland">Ireland</option>
              </select>
            </div>
          </div>
        </div>
      </section>

      {/* University Grid */}
      <section className="py-5 container">
        <div className="row g-4">
          {filtered.map((u) => (
            <div key={u.id} className="col-lg-4 col-md-6">
              <div className="consultancy-glass-card h-100 overflow-hidden d-flex flex-column justify-content-between">
                <div>
                  <div className="position-relative" style={{ height: "190px" }}>
                    <img src={u.img} alt={u.name} className="w-100 h-100" style={{ objectFit: "cover" }} />
                    <span className="position-absolute top-0 end-0 m-3 badge bg-warning text-dark font-weight-bold px-3 py-1.5 rounded-pill shadow">
                      {u.rank}
                    </span>
                  </div>
                  <div className="p-4">
                    <div className="d-flex justify-content-between align-items-center mb-1">
                      <span className="small text-warning font-weight-bold">{u.flag} {u.country}</span>
                    </div>
                    <h5 className="font-weight-bold consultancy-gold-title mb-2">{u.name}</h5>

                    <div className="small text-muted mb-2">
                      <i className="fas fa-coins text-warning mr-2"></i> Annual Tuition: <strong className="text-white">{u.fee}</strong>
                    </div>
                    <div className="small text-muted mb-3">
                      <i className="fas fa-book-open text-warning mr-2"></i> Top Programs: <strong className="text-white">{u.popular}</strong>
                    </div>
                  </div>
                </div>

                <div className="p-4 pt-0 d-flex gap-2">
                  <Link to={`/consultancy/universities/${u.id}`} className="consultancy-btn-gold flex-grow-1 text-center py-2">
                    View Profile
                  </Link>
                  <Link to="/consultancy/book-consultation" className="consultancy-btn-outline-gold py-2 px-3">
                    Apply Now
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <ConsultancyFooter />
    </div>
  );
};

export default UniversitiesPage;
